<template>
  <div class="flex">
    <v-label v-if="label">
      <span class="d-block title-content mb-0">
        {{ label || 'Image Upload' }}
      </span>
    </v-label>
    <v-row justify-center class="media-dropzone-layout">
      <v-col>
        <v-card width="100%" raised class="v-sheet--tile">
          <v-progress-linear v-if="uploading" :indeterminate="true" />
          <input
            type="file"
            accept="image/*"
            :multiple="allowMultiple"
            class="dzImageUploadBtn"
            ref="dzImageUploadBtn"
            @change="imageSelected($event)"
          />
          <v-container
            :style="`min-height: ${containerMinHeight};`"
            class="dz-main-container pa-0"
            fluid
            grid-list-md
            @dragover.prevent="draggedOver"
            @dragenter.prevent="dragEntered"
            @dragleave.prevent="dragLeft"
            @drop.prevent="filesDropped"
            @click.prevent.stop="$refs.dzImageUploadBtn.click()"
          >
            <v-row row wrap fill-height class="ma-0">
              <v-col
                v-for="(file, index) in files"
                :key="index"
                v-bind="
                  allowMultiple ? { xs: 6, sm: 6, md: 6, lg: 6 } : { xs: 12 }
                "
              >
                <v-card class="dz-image-holder" tile>
                  <v-img
                    :src="file.url"
                    lazy-src="/placeholder.jpg"
                    :height="imageHeight"
                    style="position: relative;"
                  >
                    <v-chip
                      :color="file.id ? `green` : `orange`"
                      icon
                      text
                      absolute
                      text-color="white"
                      small
                    >
                      <span v-if="file.id">
                        <v-icon small>$uploaded</v-icon>
                      </span>
                      <span v-else> <v-icon>$upload</v-icon> Pending </span>
                    </v-chip>
                  </v-img>
                  <v-col
                    class="dz-overlay pa-0 text-md-right"
                    grow
                    @mouseleave="onMouseLeaveImage(index)"
                  >
                    <!--                    <v-container grid-list-xs fluid justify-center pa-0>-->
                    <!--                      <v-row column pa-0 ma-0>-->
                    <!--                        <v-col-->
                    <!--                          v-if="allowMultiple"-->
                    <!--                          xs12-->
                    <!--                          pa-0-->
                    <!--                          class="white&#45;&#45;text text-xs-center advanced-action"-->
                    <!--                        >-->
                    <!--                          <v-col pa-0 xs8 offset-xs2>-->
                    <!--                            <v-text-field-->
                    <!--                              label="Featured"-->
                    <!--                              v-model="file.featured_index"-->
                    <!--                              class="white&#45;&#45;text"-->
                    <!--                            >-->
                    <!--                              <template v-slot:prepend>-->
                    <!--                                <div-->
                    <!--                                  class="counter"-->
                    <!--                                  @click="decreaseFeaturedIndex(file)"-->
                    <!--                                >-->
                    <!--                                  <v-icon>$minus</v-icon>-->
                    <!--                                </div>-->
                    <!--                              </template>-->
                    <!--                              <template v-slot:append-outer>-->
                    <!--                                <div-->
                    <!--                                  class="counter"-->
                    <!--                                  @click="increaseFeaturedIndex(file)"-->
                    <!--                                >-->
                    <!--                                  <v-icon>$plus</v-icon>-->
                    <!--                                </div>-->
                    <!--                              </template>-->
                    <!--                            </v-text-field>-->
                    <!--                          </v-col>-->
                    <!--                        </v-col>-->
                    <!--                        <div-->
                    <!--                          class="dz-text pa-0 xs12 white&#45;&#45;text text-xs-center"-->
                    <!--                        >-->
                    <!--                          {{ file.name }}-->
                    <!--                        </div>-->
                    <!--                      </v-row>-->
                    <!--                    </v-container>-->
                    <v-btn
                      icon
                      style="color: white; z-index: +2"
                      absolute
                      fab
                      right
                      small
                      top
                      class="mt-3 mr-n6"
                      @click.prevent.stop="remove($event, file, index)"
                    >
                      <v-icon>$delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-card>
              </v-col>
              <v-col
                v-if="!files.length"
                xs12
                class="text-center body-1 font-weight-bold"
                :class="{ 'error--text': errors.length }"
              >
                <v-icon dark class="black--text mr-4 my-2">$uploaded</v-icon>
                Upload Photos
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>

    <ValidationProvider
      ref="validator"
      :name="fieldName"
      :rules="required ? 'required' : ''"
      v-slot="{ errors }"
    >
      <input type="hidden" :name="fieldName" v-model="count" />
      <div
        v-if="errors.length"
        class="v-messages theme--light error--text"
        role="alert"
      >
        <div class="v-messages__wrapper">
          <div class="v-messages__message">{{ errors[0] }}</div>
        </div>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import Media from '@models/Media';

export default {
  name: `DropZone`,
  props: {
    remoteFiles: {
      type: [Array, Object],
      default: () => [],
    },
    subjectId: {
      type: Number,
      default: null,
    },
    subjectType: {
      type: String,
      required: true,
      default: 'default',
    },
    category: {
      type: String,
      required: true,
    },
    allowMultiple: {
      type: Boolean,
      default: true,
    },
    imageHeight: {
      type: String,
      default: `100%`,
    },
    containerMinHeight: {
      type: String,
      default: `50px`,
    },
    label: {
      type: String,
      default: 'Upload media',
    },
    required: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      uploading: false,
      dragActive: false,
      files: [],
      cacheFiles: [],
      count: '',
    };
  },
  watch: {
    remoteFiles() {
      this.readRemoteFiles();
    },
    files() {
      this.count = this.files.length > 0 ? 'has-image' : '';
    },
  },
  computed: {
    fieldName() {
      return this.name || `${this.subjectType}_${this.category}`;
    },
    errors() {
      return this.$refs.validator ? this.$refs.validator.errors : [];
    },
  },
  methods: {
    reset() {
      this.files = [];
    },
    readRemoteFiles() {
      this.files = [];
      let remoteFiles = !Array.isArray(this.remoteFiles)
        ? this.remoteFiles
          ? [this.remoteFiles]
          : []
        : this.remoteFiles || [];
      this.files = this.clone(remoteFiles);
      this.sortByFeaturedIndex();
      this.cacheFiles = this.clone(this.files);
    },
    dragEntered(event) {
      this.$emit('dragEntered');
    },
    draggedOver(event) {
      this.dragActive = true;
      this.$emit('draggedOver');
    },
    dragLeft(event) {
      this.dragActive = false;
      this.$emit('dragLeft');
    },
    imageSelected(event) {
      let files = event.target.files;
      this.readRawFiles(files);
    },
    filesDropped(event) {
      this.dragActive = false;
      let files = event.dataTransfer.files;
      this.readRawFiles(files);
    },
    readRawFiles(files) {
      if (!this.allowMultiple) {
        this.files = [];
        if (files.length > 1) {
          $showError('You may only select a single image.', 'media-error');
          files = [files[0]]; // files is not an array
        }
      }
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          this.files = this.files.concat([
            {
              id: null,
              url: e.target.result,
              name: file.name,
              size: file.size,
              alt_text: '',
              file,
              featured_index: null,
            },
          ]);
        };
      }
    },
    increaseFeaturedIndex(file) {
      if (isNaN(parseInt(file.featured_index))) {
        return (file.featured_index = 1);
      }
      if (parseInt(file.featured_index) > 9999) {
        return (file.featured_index = 9999);
      }
      return file.featured_index++;
    },
    decreaseFeaturedIndex(file) {
      if (isNaN(parseInt(file.featured_index))) {
        return (file.featured_index = 1);
      }
      if (parseInt(file.featured_index) < 2) {
        return (file.featured_index = 1);
      }
      return file.featured_index--;
    },
    async upload(id = this.subjectId) {
      await this.$nextTick();
      let filesToUpload = this.files.filter((file) => !file.id);
      if (filesToUpload.length === 0) {
        return;
      }
      this.uploading = true;
      let mediaModel = new Media();
      let formData = new FormData();
      formData.append('subject_id', parseInt(id));
      formData.append('subject_type', this.subjectType);
      formData.append('category', this.category);
      filesToUpload.forEach((file, index) => {
        formData.append(`files[${index}]`, file.file);
        formData.append(
          `properties[${index}]`,
          JSON.stringify({
            featured_index: file.featured_index,
          })
        );
      });
      try {
        let response = await mediaModel.save(formData);
        let newUploadedFiles = response.data;
        let oldUploadedFiles = this.files.filter((file) => !!file.id);
        this.files = oldUploadedFiles.concat(newUploadedFiles);
        this.sortByFeaturedIndex();

        return response;
      } catch (error) {
        throw new Error(
          'Oops! One or more files failed to upload.',
          'media-dropzone-error'
        );
      } finally {
        this.uploading = false;
      }
    },
    async onMouseLeaveImage(mediaIndex) {
      if (!this.allowMultiple) {
        return;
      }
      let media = this.files[mediaIndex];
      if (!media.id) {
        this.sortByFeaturedIndex();
        return;
      }
      await this.updateSingleMedia(media);
    },
    async updateSingleMedia(media) {
      if (this.hasMediaChanged(media)) {
        let model = new Media();
        try {
          await model.save(media);
          this.sortByFeaturedIndex();
          this.cacheFiles = this.clone(this.files);
        } catch (error) {
          this.handleMediaErrors(mediaIndex, error);
        }
      }
    },
    hasMediaChanged(media) {
      let originalMedia = this.cacheFiles.find(
        (original) => original.id === media.id
      );
      if (originalMedia) {
        return (
          media.alt_text !== originalMedia.alt_text ||
          media.featured_index != originalMedia.featured_index ||
          media.name !== originalMedia.name
        );
      }
      return false;
    },
    sortByFeaturedIndex() {
      this.files.sort((a, b) => {
        if (!a.featured_index || !b.featured_index) {
          return b.featured_index - a.featured_index;
        }
        return a.featured_index - b.featured_index;
      });
    },
    handleMediaErrors(index, error) {
      if (error.response.status === 422) {
        $showError(
          'Oops! Something went wrong while updating image.',
          'media-dropzone-error'
        );
      }
    },
    getFiles() {
      let uploadedFiles = this.files.filter((file) => !!file.id);
      if (this.allowMultiple) {
        return uploadedFiles;
      }
      return uploadedFiles[0] ? uploadedFiles[0] : {};
    },
    async remove(event, file, index) {
      event.preventDefault() && event.stopPropagation();
      if (await $question('Are you sure, you want to delete?')) {
        try {
          this.uploading = true;
          if (file.id) {
            let mediaModel = new Media();
            await mediaModel.delete(file.id);
          }
          this.files.splice(index, 1);
          $showSuccess('Deleted successfully', `media-dropzone-remove`);
        } catch (error) {
          $showError(error.message, `media-dropzone-remove`);
        } finally {
          this.uploading = false;
        }
      }
    },
  },
  mounted() {
    this.readRemoteFiles();
  },
};
</script>

<style lang="scss">
.dz-overlay {
  display: flex;
  cursor: default !important;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.5s ease;
  background-color: rgba(0, 140, 186, 0.8);

  .advanced-action {
    max-height: 70px !important;
  }

  .fab {
    border-radius: 50%;
    right: 0;
    margin: 0 !important;
    top: 0 !important;
    padding: 0;
    background-color: rgba(10, 10, 10, 0.4) !important;
  }

  .white--text {
    .v-label {
      color: white !important;
    }

    .counter {
      cursor: pointer;
    }

    input {
      color: white !important;
    }
  }
}

.dz-image-holder:hover .dz-overlay {
  opacity: 1;
}

.dz-text {
  color: white;
  width: 100%;
  font-size: 12px;
  text-align: center !important;
}

.media-dropzone-layout .v-icon {
  color: white;
}

.dz-main-container {
  /*border: 2px dashed #ccc;*/
  cursor: pointer;
}

.dzImageUploadBtn {
  display: none;
}
</style>
